import { api, handleError } from "./baseApi";

export async function addOperator(name, email, phone_number, referral_code) {
  try {
    const { data } = await api.post("/operator", {
      name,
      email,
      phone_number,
      referral_code: referral_code || "",
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function getOperatorById(operatorId) {
  try {
    const { data } = await api.get(`/operator/${operatorId}`);
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function getAllOperators(params = {}) {
  try {
    Object.keys(params).forEach((key) => {
      if (!params[key]) delete params[key];
    });

    const { data } = await api.get("/operator", { params });
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function updateOperator(operatorId, name, email, phone_number, referral_code) {
  try {
    const { data } = await api.put(`/operator/${operatorId}`, {
      name,
      email,
      phone_number,
      referral_code,
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function deleteOperator(operatorId) {
  try {
    const { data } = await api.delete(`/operator/${operatorId}`);
    return data;
  } catch (error) {
    return handleError(error);
  }
}
